import * as API from "middleware/api";

export const adheredServicesList = (userCode) => API.executeWithAccessToken(`/rapipago.service.list`, { userCode });
export const adheredServicesDetail = (data) => API.executeWithAccessToken(`/rapipago.service.detail`, { ...data });
export const adheredServicesRename = (data) => API.executeWithAccessToken(`/rapipago.service.rename`, { ...data });
export const adheredServicesUnbind = (data) => API.executeWithAccessToken(`/rapipago.service.remove`, { ...data });
